import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";

import { useNavigate } from "react-router-dom";

import { AzureProfile } from "sso/azure/ui/AzureProfile";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "sso/azure/authConfig";
import { getAzureToken } from "sso/azure/azure-api";

import { SimpleHeader } from "components/ui/SimpleHeader";
import logoPremioPrincipal from "assets/img/2026/logo_premio_page.png";
import logoPremioBB from "assets/img/2026/logo_premio.png";
import personagemPerfil from "assets/img/2026/personagem_perfil_BB.png";
import SpaceLogin from "assets/img/2026/estrelas_fundo.png";
import "../LoginPublic/style.scss";
import { ativarModoSimulacao } from "utils/modo-simulacao";

export function Login() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [autoLoading, setAutoLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [useSSO, setUseSSO] = useState(false);
  const { loginWithToken, login } = useContext(AuthContext);

  function handleSSOClick() {
    instance.loginPopup(loginRequest);
    setTimeout(() => {
      setLoading(true);
      setUseSSO(true);
    }, 200);
  }

  async function handleLoginSSO(response: any) {
    try {
      const password = await getAzureToken();
      const username = response.userPrincipalName;

      if (username && password) {
        await login({ username, password }, "sso_azure");
      }
      navigate("/");
    } catch (e) {
      setLoading(false);
      setUseSSO(false);
    }
  }

  useEffect(() => {
    async function doLogin(username: string, password: string) {
      try {
        await login({ username, password });
        setTimeout(() => navigate("/"), 150);
      } catch (e) {
        setAutoLoading(false);
      }
    }

    async function doLoginWithToken(token: string) {
      try {
        await loginWithToken(token);
        setTimeout(() => navigate("/"), 150);
      } catch (e) {
        setAutoLoading(false);
      }
    }

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const agent = params.get("agent");
    const secret = params.get("secret");
    const tokenItem = params.get("tokenItem");

    if (token) {
      setAutoLoading(true);
      doLoginWithToken(token);
    } else if (agent && secret) {
      setAutoLoading(true);
      doLogin(agent, secret);
    } else if (tokenItem) {
      setAutoLoading(true);
      const decoded = atob(tokenItem);
      const [id, pwd] = decoded.split(":");
      ativarModoSimulacao();
      doLogin(id, pwd);
    }
  }, [loginWithToken, login, navigate]);

  if (autoLoading) {
    return (
      <div className="login-public-bg flex items-center justify-center w-screen h-screen">
        <span className="text-white text-xl font-bold">CARREGANDO...</span>
      </div>
    );
  }

  return (
    <div id="login-public-wrapper">
      <div className="relative flex flex-col w-screen h-screen bg-gradient-to-br from-blue-bb via-blue-bb-1 to-blue-bb-5 overflow-hidden">
        <div className="absolute inset-0 z-0" aria-hidden="true">
          <img src={SpaceLogin} alt="" className="w-full h-full object-cover" />
        </div>

        <div className="absolute top-0 left-0 right-0 z-50">
          <SimpleHeader title="Prêmio BB" userName="" customLogo={logoPremioBB} />
        </div>

        <main className="flex flex-1 items-center justify-center px-4 md:px-8 lg:px-12 relative pt-20 pb-4">
          <div className="flex flex-col items-center justify-center max-w-5xl z-10 w-full login-content">
            <div tabIndex={0} className="text-center mb-3 space-y-0.5">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-pink-bb leading-tight">
                <span className="block">A grande jornada com iniciativas</span>
                <span className="block">transformadoras e inspiradoras começou.</span>
              </h1>
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-blue-bb-6 leading-tight mt-1">
                Acompanhe sua iniciativa no <span className="text-yellow-bb">Prêmio BB!</span>
              </p>
            </div>

            <div className="flex flex-col items-center justify-center mb-4 gap-4">
              {!useSSO && (
                <button
                  onClick={handleSSOClick}
                  disabled={loading}
                  className="btn-iniciar-jornada"
                >
                  {loading ? "CARREGANDO..." : "ENTRAR"}
                </button>
              )}

              {useSSO && (
                <AzureProfile onAuthenticate={handleLoginSSO} />
              )}
            </div>

            <div
              tabIndex={0}
              aria-label="Logo do Prêmio e Personagem"
              className="relative flex items-end justify-center images-container"
            >
              <div className="relative z-20">
                <img
                  src={personagemPerfil}
                  alt=""
                  aria-hidden="true"
                  className="h-40 md:h-48 lg:h-60 w-auto object-contain"
                />
              </div>
              <div className="relative z-10 -ml-6 md:-ml-8 lg:-ml-10">
                <img
                  src={logoPremioPrincipal}
                  alt="Logo Prêmio BB"
                  className="h-56 md:h-64 lg:h-80 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
